import { render, staticRenderFns } from "./WeekendSchedulePage.vue?vue&type=template&id=4d17095d&scoped=true&"
import script from "./WeekendSchedulePage.vue?vue&type=script&lang=js&"
export * from "./WeekendSchedulePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d17095d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
